module.exports = {"pathContext":{"name":"CensusHistoryEventEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"CensusHistoryEvent","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-census-history-event-edge.json
// module id = 1686
// module chunks = 50010302253903